import React from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { CircularProgress, makeStyles } from "@material-ui/core";

const useStyles = makeStyles({
	alignCenter: {
		textAlign: "center",
	},
	content: {
		display: "flex",
		flexDirection: "column",
		alignItems: "center",
		maxWidth: 480,
	},
	actions: {
		display: "flex",
		justifyContent: "center",
		gap: 12,
	},
});

const StripeQuantityModal = ({
	open,
	loading,
	previewLoading,
	preview,
	hostsQuantity,
	monthlyPrice,
	onConfirm,
	handleClose,
}) => {
	const classes = useStyles();
	const isDecrease = preview?.change === "decrease";
	const isRevert = preview?.change === "revert";
	const confirmLabel = isDecrease
		? "Schedule decrease"
		: isRevert
			? "Keep current hosts"
			: "Confirm and pay";

	return (
		<Dialog
			open={open}
			onClose={loading ? undefined : handleClose}
			aria-labelledby="stripe-quantity-title"
		>
			<DialogTitle className={classes.alignCenter} id="stripe-quantity-title">
				Update card subscription
			</DialogTitle>
			<DialogContent className={classes.content}>
				{previewLoading ? (
					<CircularProgress size={36} style={{ color: "#635BFF", margin: "12px 0" }} />
				) : (
					<>
						<DialogContentText className={classes.alignCenter}>
							{preview?.message ||
								`${hostsQuantity} hosts will bill at $${monthlyPrice}/month. Stripe charges a prorated amount for the rest of this period when you add hosts.`}
						</DialogContentText>
						{preview?.portalUrl && (
							<Button
								href={preview.portalUrl}
								target="_blank"
								rel="noopener noreferrer"
								color="primary"
								style={{ marginTop: 8 }}
							>
								Update card
							</Button>
						)}
					</>
				)}
				{loading && (
					<CircularProgress size={32} style={{ color: "#635BFF", marginTop: 12 }} />
				)}
			</DialogContent>
			<DialogActions className={classes.actions}>
				<Button onClick={handleClose} disabled={loading} color="primary">
					Go back
				</Button>
				<Button
					onClick={onConfirm}
					disabled={loading || previewLoading || preview?.blocked}
					variant="contained"
					style={{ background: "#635BFF", color: "#fff" }}
				>
					{confirmLabel}
				</Button>
			</DialogActions>
		</Dialog>
	);
};

export default StripeQuantityModal;
